import { find, size } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';
import S from 'modules/publish/styles';

import { Loader, Scrollbars } from 'modules/common/components';
import { MODAL_HEIGHT, views } from 'modules/publish/constants';
import { useStatesAndCountries } from 'modules/common/hooks';

import { AddressFormView, AddressListView } from './views';

const AddressView = ({
  // Data
  activeView,
  addresses,
  countries,
  formAddressId,
  loading,
  selectedAddressId,
  states,
  isDentistProject = false,
  setAddresses = [],

  // Callbacks
  onCreate,
  onDelete,
  onEdit,
  onSelect,
  setActiveView,
  setFormAddressId,
}) => {
  if (loading) {
    return <Loader height="100%" title="Loading addresses" />;
  }

  // getting countries and states
  let newStates = states;
  let newCountires = countries;
  if (isDentistProject) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { states: statess, countries: countriess } = useStatesAndCountries();
    newCountires = countriess.map((items) => items.title);
    const updatedStates = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [country, items] of Object.entries(statess)) {
      updatedStates[country] = items.map((item) => item.title);
    }
    newStates = updatedStates;
  }
  const setState = (view, id) => {
    setFormAddressId(id);
    setActiveView(view);
  };

  const handleCreate = () => setState(views.ADDRESS_FORM, null);

  const handleEdit = (id) => setState(views.ADDRESS_FORM, id);

  const handleDelete = (id) => {
    onDelete(id);
    if (isDentistProject) {
      const updatedAddresses = addresses.filter((item) => item._id !== id);
      setAddresses(updatedAddresses);
    }
    setState(views.ADDRESS_LIST, null);
  };

  const handleSubmit = (fields) => {
    const callback = !formAddressId ? onCreate : onEdit;
    const cbResult = callback(fields);
    if (isDentistProject) {
      const idName = uuidv4();
      let resultArray;
      if (formAddressId) {
        resultArray = addresses.filter((item) => item._id !== formAddressId);
      } else {
        resultArray = addresses;
      }
      cbResult
        .then((result) => {
          if (!formAddressId) {
            const response = result?.payload;
            response._id = idName;
            resultArray.push(response);
          } else {
            resultArray.push(result?.payload);
          }
          setAddresses(resultArray);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setState(views.ADDRESS_LIST, null);
  };

  const handleCancel = () => setState(views.ADDRESS_LIST, null);

  const selectedAddress = find(addresses, ({ _id }) => _id === formAddressId);
  const hasAddresses = size(addresses) > 0;

  const Renderer = () => {
    switch (activeView) {
      case views.ADDRESS_LIST:
        return (
          <AddressListView
            selectedAddressId={selectedAddressId}
            addresses={addresses}
            onSelect={onSelect}
            onCreate={handleCreate}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        );

      case views.ADDRESS_FORM:
        return (
          <AddressFormView
            formAddressId={formAddressId}
            fields={selectedAddress}
            countries={newCountires}
            states={newStates}
            onSubmit={handleSubmit}
            onCancel={hasAddresses && handleCancel}
          />
        );

      default:
        return null;
    }
  };

  return <Renderer />;
};

export const ModalAddressView = (props) => (
  <Scrollbars style={{ height: MODAL_HEIGHT }}>
    <S.ViewTitle>Shipping Address</S.ViewTitle>
    <AddressView {...props} />
  </Scrollbars>
);

export default AddressView;
